<template>
	<div class="all" id="all">
		<div class="flex-content" :key="index" v-for="(item,index) in list">
			<div class="g-infor">
				<div class="g-headimg">
					<img :src="consultDefaultHeadimg" v-if="item.dialogues[0].sender==1" />
					<img :src="item.sendHeadimg" v-if="item.dialogues[0].sender==2" />
				</div>
				<div class="talk_record">
					<div class="ename" v-if="item.dialogues[0].sender===1">{{consultNickName}}</div>
					<div class="ename" v-if="item.dialogues[0].sender===2">{{item.sendNickName}}</div>
					<div class="talk_content">
						<span :key="indexs" v-for="(items,indexs) in item.dialogues">
							<img v-if="items.messageType===2" :src="items.content" v-image-preview />
							<video v-else-if="items.messageType===3" :src="items.content" controls="controls"></video>
							<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
							<p v-else-if="items.messageType===12" id="rowText">{{items.content}}</p>
							<p v-else-if="items.messageType===13" style="border-bottom:1px dashed #ccc;margin:10px 0;"></p>
							<span v-else>{{items.content}}</span>
						</span>
					</div>
				</div>
			</div>
			<div class="creatime">{{getTime(item.sendTime)}}</div>
		</div>

		<div v-show="list.length==0" class="list_text">暂无数据</div>
		<div class="list_text" v-show="searchLoading">
			<i class="el-icon-loading"></i> 加载中...
		</div>
		<div class="list_text" v-show="noMore">没有更多了</div>
	</div>
</template>
<script>
import { FormatTimes } from '@/utils/FormatTime'
export default {
	name: 'historicalRecord',
	data() {
		return {}
	},
	props: {
		list: {
			type: Array,
			default: () => []
		},
		consultNickName: {
			type: String,
			default: ''
		},
		consultDefaultHeadimg: {
			type: String,
			default: ''
		},
		kfDefaultHeadimg: {
			type: String,
			default: ''
		},
		searchLoading: {
			type: Boolean,
			default: false
		},
		noMore: {
			type: Boolean,
			default: false
		}
	},
	watch: {},
	mounted: function() {
		var testDiv = document.getElementById('all')
		testDiv.addEventListener('scroll', this.handleScroll)
	},
	methods: {
		handleScroll() {
			var testDiv = document.getElementById('all')
			var height = testDiv.clientHeight
			var scrollTop = testDiv.scrollTop
			var scrollHeight = testDiv.scrollHeight
			if (height + scrollTop + 20 >= scrollHeight) {
				this.$emit('onReachTheBottom')
			}
		},
		getTime(time) {
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		}
	}
}
</script>
<style scoped>
.all {
	height: 500px;
	overflow-y: auto;
}
video {
	width: 150px;
	height: 150px;
}
.flex-content {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
}
.g-infor {
	width: 80%;
}
.g-headimg {
	float: left;
}
.g-headimg img {
	width: 50px;
	height: 50px;
	border-radius: 50%;
}
.talk_record {
	float: left;
	margin-left: 30px;
	width: 80%;
}
.flex-content .ename {
	color: #999;
	line-height: 25px;
}
.flex-content .talk_content {
	line-height: 25px;
}
.flex-content .creatime {
	color: #666;
	margin-right: 20px;
}
.talk_content img {
	width: 200px;
}
.list_text {
	text-align: center;
	color: #ccc;
	padding-top: 20px;
	padding-bottom: 20px;
	color: #409eff;
}
::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}
/*滚动条样式*/
::-webkit-scrollbar {
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}
#rowText {
	text-align: left;
	color: black;
	max-width: 200px;
	height: auto;
	word-wrap: break-word;
	word-break: break-all;
	line-height: 18px;
}
</style>
 


// WEBPACK FOOTER //
// src/components/customer/talks/historicalRecord.vue